var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11719 9.11719C3.62891 9.60547 3.62891 10.3984 4.11719 10.8867L11.6172 18.3867C12.1055 18.875 12.8984 18.875 13.3867 18.3867C13.875 17.8984 13.875 17.1055 13.3867 16.6172L6.76953 10L13.3828 3.38281C13.8711 2.89453 13.8711 2.10156 13.3828 1.61328C12.8945 1.125 12.1016 1.125 11.6133 1.61328L4.11328 9.11328L4.11719 9.11719Z",
    fill: "#f4fdfa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.98e37ce20de16a6655046e3a34db1e34.svg";
export { ForwardRef as ReactComponent };